import React from 'react';
import HeadLogo from '$/components/HeadLogo';
import { getEnv, navigate } from '@/common/agents';
import styles from './index.module.scss';

interface SeoHeaderProps {
  userCardWithVip?: () => React.ReactNode;
  /** 为 false 时顶栏随页面滚动，不占 fixed 层（如 Seedance 独立页） */
  fixedTop?: boolean;
  /** 布局插槽自行放置占位时关闭；默认保留原有固定导航占位。 */
  showPlaceholder?: boolean;
}

/** 复用原有 60px 占位样式，让页面可将占位保留在 main 内。 */
export function SeoHeaderPlaceholder() {
  return <div className={styles.headerPlaceholder} aria-hidden />;
}

/**
 * SEO 落地页顶栏：Logo 与右侧插槽；默认固定在视口顶部（含 iPad 提示条偏移），可通过 fixedTop 关闭。
 */
export default function SeoHeader(props: SeoHeaderProps) {
  const { userCardWithVip, fixedTop = true, showPlaceholder = true } = props;
  // const languageStore = useLanguageStore((state) => state.languageStore);
  const goHomepage = () => {
    navigate({
      mode: 'url',
      url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
    });
  };

  return (
    <>
      <header
        className={`${styles.headerWrapper} ${fixedTop ? styles.headerWrapperFixed : styles.headerWrapperFlow}`}
      >
        <div className={styles.headerInner}>
          <div
            className={styles.logoBox}
            onClick={goHomepage}
          >
            <HeadLogo className={styles.logo} />
          </div>
          <div className={styles['seo-header-right']}>
            { userCardWithVip ? userCardWithVip?.() : null}
          </div>
        </div>
      </header>
      {fixedTop && showPlaceholder ? <SeoHeaderPlaceholder /> : null}
    </>
  );
}
